import {
  SupportContextAction,
  FeedbackTab,
  SupportContextState,
} from "./support.types";

const supportContextInitialState: SupportContextState = {
  feedbackTab: FeedbackTab.NEW_FEEDBACKS,
  feedbackFilters: {
    search: "",
  },
};

const supportContextReducer = (
  state: SupportContextState,
  action: SupportContextAction
): SupportContextState => {
  switch (action.type) {
    case "SET_FEEDBACK_TAB": {
      return { ...state, feedbackTab: action.payload };
    }
    case "SET_CURRENT_CHAT": {
      return {
        ...state,
        currentChat: { ...state.currentChat, ...action.payload },
      };
    }
    case "SET_SUPPORT_USER_AUTH_TOKENS": {
      return {
        ...state,
        supportUserAuthTokens: action.payload,
      };
    }
    case "SET_FEEDBACK_FILTERS": {
      return {
        ...state,
        feedbackFilters: {
          ...state.feedbackFilters,
          ...action.payload,
        },
      };
    }

    default: {
      return state;
    }
  }
};

export { supportContextInitialState, supportContextReducer };
